/**
 * 站内信通知接口
 * @author ritaxxu
 */
import { requestApiV2 } from '@library'
import {
  IInnerMsgItem,
  IInnerMsgUnreadCount,
  IGetInnerMsgListReq,
  IMarkInnerMsgReadReq,
  ISendInnerMsgReq,
  IResendInnerMsgReq,
  IGetSendRecordListReq,
  ISendRecordItem,
  IGetSendRecordDetailReq,
  IGetSendRecordDetailRsp,
  IGetSendRecordExecuteDetailReq,
  ISendRecordRecipientItem,
  IExportSendRecordExecuteDetailReq,
} from '@types'

/** 获取我的消息列表 */
export function getInnerMsgList (params: IGetInnerMsgListReq) {
  return requestApiV2<{ total: number, list: IInnerMsgItem[] }>(
    '/trpc.tcc.tcc_main.InnerMsg/GetInnerMsgList',
    params,
  )
}

/** 获取未读消息计数（铃铛角标轮询） */
export function getInnerMsgUnreadCount () {
  return requestApiV2<IInnerMsgUnreadCount>(
    '/trpc.tcc.tcc_main.InnerMsg/GetInnerMsgUnreadCount',
  )
}

/** 标记消息已读（按 recipientIds 单条/多条 或 按 level=1 批量清除普通未读） */
export function markInnerMsgRead (params: IMarkInnerMsgReadReq) {
  return requestApiV2<{ affectedCount: number }>(
    '/trpc.tcc.tcc_main.InnerMsg/MarkInnerMsgRead',
    params,
  )
}

/** 发送站内信通知 */
export function sendInnerMsg (params: ISendInnerMsgReq) {
  return requestApiV2<{ templateId: number }>(
    '/trpc.tcc.tcc_main.InnerMsg/SendInnerMsg',
    params,
  )
}

/** 再次发送（复用原模板配置，仅传 templateId；30 分钟冷却） */
export function resendInnerMsg (params: IResendInnerMsgReq) {
  return requestApiV2<{}>(
    '/trpc.tcc.tcc_main.InnerMsg/ResendInnerMsg',
    params,
  )
}

/** 获取发送记录列表 */
export function getSendRecordList (params: IGetSendRecordListReq) {
  return requestApiV2<{ total: number, list: ISendRecordItem[] }>(
    '/trpc.tcc.tcc_main.InnerMsg/GetSendRecordList',
    params,
  )
}

/** 获取发送记录详情（按模板列出所有触发实例） */
export function getSendRecordDetail (params: IGetSendRecordDetailReq) {
  return requestApiV2<IGetSendRecordDetailRsp>(
    '/trpc.tcc.tcc_main.InnerMsg/GetSendRecordDetail',
    params,
  )
}

/** 获取单次执行的接收人列表 */
export function getSendRecordExecuteDetail (params: IGetSendRecordExecuteDetailReq) {
  return requestApiV2<{ total: number, list: ISendRecordRecipientItem[] }>(
    '/trpc.tcc.tcc_main.InnerMsg/GetSendRecordExecuteDetail',
    params,
  )
}

/** 导出单次执行接收人列表（异步任务，磐石通过邮件/RTX 卡片下发下载链接） */
export function exportSendRecordExecuteDetail (params: IExportSendRecordExecuteDetailReq) {
  return requestApiV2<{}>(
    '/trpc.tcc.tcc_main.InnerMsg/ExportSendRecordExecuteDetail',
    params,
  )
}

/** 撤销/删除模板 */
export function cancelInnerMsg (params: { templateId: number }) {
  return requestApiV2<{}>(
    '/trpc.tcc.tcc_main.InnerMsg/CancelInnerMsg',
    params,
  )
}
